import React, { useRef } from "react";

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

function ImportExcel({ onImportSuccess, viewerName }) {
  const inputRef = useRef();

  const handleClick = () => {
    inputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await fetch(`${API}/api/import`, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) throw new Error("Erreur import");

      // ✅ AJOUT : enregistre qui a importé + la date (visible par tout le monde)
      try {
        await fetch(`${API}/api/meta/last-import`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ by: viewerName || "" }),
        });
      } catch (e2) {
        // on ne bloque pas l'import si la méta échoue
        console.error("Impossible d’enregistrer le dernier import :", e2);
      }

      if (onImportSuccess) onImportSuccess();
    } catch (err) {
      alert("Erreur lors de l'import");
      console.error(err);
    }

    e.target.value = "";
  };

  return (
    <>
      <button onClick={handleClick}>Importer un Excel</button>
      <input
        type="file"
        ref={inputRef}
        style={{ display: "none" }}
        accept=".xlsx,.xls"
        onChange={handleFileChange}
      />
    </>
  );
}

export default ImportExcel;
